// @ts-nocheck
import type { PageState } from 'src/@types'
import { useMemo } from 'react'
import { I18NS, QR_CODE_STATUS, getLocationParams } from 'src/utils'
import { getApi, getApiNoLoading } from 'src/api'
// import { testData as res } from '../test'

interface Params {
  setState: UseStatesDispatch<PageState>
  getNewState: () => PageState
}

export function usePageUtils({ setState, globalStore, getNewState }: Params) {
  return useMemo(() => {

    const i18nsMap = {}

    let token = '' // 二维码token

    async function initState() {
      const { client_id } = getLocationParams()
      const res = await getApi(`/login/page/getConfig?client_id=${client_id ?? ''}`)()
      const requestData = res.data
      if (!requestData) return
      // 取出所有的国际化数据
      const { qrcodeEnabled, supportLocales, i18ns } = requestData
      // 默认第一个为选中的语言
      let lang = localStorage.getItem('lang')
      if (!i18ns.some(t => t.id === lang)) {
        lang = supportLocales[0].lang
      }
      i18ns.forEach(t => { i18nsMap[t.id] = t.child })
      I18NS.i18ns = i18nsMap[lang]
      toggleLang(lang)
      qrcodeEnabled && getQRCode()
      globalStore.data = requestData
      setState({
        isInit:           false,
        warningWordColor: requestData?.warningWordColor,
        choseUser:        requestData?.appUsers?.[0] ?? null,
        requestData
      })
    }

    function toggleLang(lang: string) {
      localStorage.setItem('lang', lang)
      I18NS.i18ns = i18nsMap[lang]
      setState({
        lang,
        footerText: (I18NS.BOTTOM_INFO_WORD || '').trim().replace(/ /g, '&nbsp;').split('\n').map(t => t.split(' ').filter(t => t))
      })
    }

    async function getQRCode() {
      const res = await getApi('/login/scan?event=login.scan.getQrCode')()
      if (res.data === livecloud.REQUEST_ERROR) return
      const tokenStr = livecloud.base64.decode(res?.data || '')
      const tokenJson = JSON.parse(tokenStr || '{}')
      token = tokenJson?.token || ''
      setState({ qrCode: res.data, qrCodeMsg: '' })
      pollingQRCode()
    }

    /**扫码成功后刷新登录状态 */
    const listenerLoginStatus = async () => {
      const res = await getApi('/login/scan?event=login.scan.listenerLoginStatus&token=' + token)()
      if (res.data === livecloud.REQUEST_ERROR) return
      const { loginScanStatus } = res.data
      if (loginScanStatus === QR_CODE_STATUS.COMPLETE) {
        window.location.reload()
      } else {
        setState({
          qrCodeMsg: res?.data?.loginScanMsg || ''
        })
      }
    }

    // 轮询二维码状态
    function pollingQRCode() {
      if (!token) return

      let timer = ''

      const cancelPolling = () => {
        if (window.requestAnimationFrame) {
          timer && window.cancelAnimationFrame(timer)
        } else {
          timer && clearInterval(timer)
        }
      }

      const polling = async () => {
        cancelPolling()
        const res = await getApiNoLoading('/login/scan?event=login.scan.listenerQrCodeStatus&token=' + token)()
        if (res.data === livecloud.REQUEST_ERROR) {
          cancelPolling()
          return
        }
        const { loginScanStatus } = res.data
        switch (loginScanStatus) {
          case QR_CODE_STATUS.COMPLETE:
            cancelPolling()
            listenerLoginStatus()
            break
          case QR_CODE_STATUS.CANCEL:
          case QR_CODE_STATUS.FAIL:
          case QR_CODE_STATUS.EXPIRE:
            cancelPolling()
            setState({
              qrCodeMsg: res?.data?.loginScanMsg || ''
            })
            break
          default:
            break
        }
      }

      if (window.requestAnimationFrame) {
        let lastTime = 0
        const step = (timestamp) => {
          if (timestamp - lastTime > 1000) {
            polling()
            lastTime = timestamp
          }
          timer = window.requestAnimationFrame(step)
        }
        timer = window.requestAnimationFrame(step)
      } else {
        // 监听离开页面和进入页面
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'hidden') {
            clearInterval(timer)
          } else {
            timer = setInterval(polling, 1000)
          }
        })
      }

    }

    /** 角色选择登录 */
    async function handleChoseLogin(t) {
      const {
        response_type,
        state,
        redirect_uri,
        client_id,
        casLogin
      } = getLocationParams()
      const _client_id = t.client_id ? t.client_id : (client_id ?? '')
      window.location.replace(`${window.location.origin}${livecloud.basename}/user/app/switchUser?client_id=${_client_id}&casLogin=${casLogin}&userId=${t.userId ?? ''}&redirect_uri=${redirect_uri}&state=${state}&response_type=${response_type}`)
    }

    return {
      /** 初始化 */
      initState,
      /** 修改语言 */
      toggleLang,
      /** 获取二维码/刷新二维码 */
      getQRCode,
      /** 轮询二维码状态 */
      pollingQRCode,
      /**角色选择登录 */
      handleChoseLogin
    }

  }, [])
}